import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AppState } from '@app/reducers';
import {
  CrudType, CustomDirectiveConfig, debounceTimeForSearchkeyword,
  LoggedInUserModel, ModulesBasedApiSuffix, PERMISSION_RESTRICTION_ERROR, prepareGetRequestHttpParams,
  prepareRequiredHttpParams,
  ResponseMessageTypes,
  RxjsService,
  SnackbarService
} from '@app/shared';
import { CrudService } from '@app/shared/services';
import { TableFilterFormService } from '@app/shared/services/create-form.services';
import { MomentService } from '@app/shared/services/moment.service';
import { InventoryModuleApiSuffixModels } from '@modules/inventory/shared';
import { loggedInUserData } from '@modules/others';
import { UserLogin } from '@modules/others/models';
import { select, Store } from '@ngrx/store';
import { combineLatest, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-job-selection-technician-stock-take-list',
  templateUrl: './job-selection-technician-stock-take-list.component.html',
  styleUrls: ['./job-selection-technician-stock-take-list.component.scss']
})
export class JobSelectionTechnicianStockTakeListComponent implements OnInit {

  isAnAlphaNumericOnly = new CustomDirectiveConfig({ isAnAlphaNumericOnly: true });
  userData: UserLogin;
  searchForm: FormGroup;
  observableResponse: any;
  dataList: any
  status: any = [];
  selectedRows: string[] = [];
  selectedRow: any;
  selectedTabIndex: any = 0;
  totalRecords: any;
  pageLimit: number[] = [10, 25, 50, 75, 100];
  loggedInUserData: LoggedInUserModel;
  primengTableConfigProperties: any;
  pageSize: number = 10;
  columnFilterForm: FormGroup;
  searchColumns: any
  row: any = {}
  loading: boolean;
  isScan : boolean = false;
  today: any = new Date();
  isEdit = 0
  otherParams;
  scanQrInput;
  constructor(
    private commonService: CrudService, private tableFilterFormService: TableFilterFormService,
    private router: Router, private activatedRoute: ActivatedRoute,
    private _fb: FormBuilder, private momentService: MomentService,
    private rxjsService: RxjsService,
    private store: Store<AppState>, private snackbarService: SnackbarService
  ) {
    this.store.pipe(select(loggedInUserData)).subscribe((userData: UserLogin) => {
      if (!userData) return;
      this.userData = userData;
    });

    this.primengTableConfigProperties = {
      tableCaption: "Technician Stock Take",
      breadCrumbItems: [{displayName:"Inventory Management"},{ displayName: 'Job Selection', relativeRouterUrl: '/inventory/job-selection' },
      { displayName: 'Technician Stock Take', }],
      selectedTabIndex: 0,
      tableComponentConfigs: {
        tabsList: [
          {
            caption: 'Technician Stock Take',
            dataKey: 'techStockTakeId',
            enableBreadCrumb: true,
            enableAction: true,
            enableScrollable: true,
            enableFieldsSearch: true,
            enableHyperLink: true,
            cursorLinkIndex: 0,
            enablePrintBtn: true,
            enableScanActionBtn: true,
            printTitle: 'Technician Stock Take',
            printSection: 'print-section0',
            columns: [{ field: 'techStockTakeInitiationNumber', header: 'Tech Stock Take ID' },
            { field: 'countNumber', header: 'Count', width: '100px' },
            { field: 'qrCode', header: 'QR Code', width: '100px' },
            { field: 'techStockLocation', header: 'Tech Stock Location' },
            { field: 'techStockLocationName', header: 'Tech Stock Location Name', width: '200px' },
            { field: 'techArea', header: 'Tech Area' },
            { field: 'techStockTakeStatusName', header: 'Status', width: '100px' }],
            enableExportBtn: true,
            isDateWithTimeRequired: true,
            apiSuffixModel: InventoryModuleApiSuffixModels.TECHNICIAN_STOCK_TAKE,
            moduleName: ModulesBasedApiSuffix.TECHNICIAN,
          }
        ]
      }
    }

    this.searchForm = this._fb.group({ searchKeyword: "" });
    this.columnFilterForm = this._fb.group({});

    this.activatedRoute.queryParamMap.subscribe((params) => {
      this.isEdit = +params['params']['isEdit']
      });

  }

  ngOnInit(): void {
    this.columnFilterForm = this.tableFilterFormService.createFormGroup(this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].columns);
    this.searchKeywordRequest();
    this.columnFilterRequest();
    this.combineLatestNgrxStoreData()
    this.getRequiredListData();
  }


  combineLatestNgrxStoreData() {
    combineLatest(
      this.store.select(loggedInUserData)
    ).subscribe((response) => {
      this.loggedInUserData = new LoggedInUserModel(response[0]);
    });
  }

  searchKeywordRequest() {
    this.searchForm.valueChanges
      .pipe(
        debounceTime(debounceTimeForSearchkeyword),
        distinctUntilChanged(),
        switchMap(val => {
          return of(this.onCRUDRequested(CrudType.GET, {}));
        })
      )
      .subscribe();
  }

  columnFilterRequest() {
    this.columnFilterForm.valueChanges
      .pipe(
        debounceTime(debounceTimeForSearchkeyword),
        distinctUntilChanged(),
        switchMap(obj => {
          Object.keys(obj).forEach(key => {
            if (obj[key] === "") {
              delete obj[key]
            }
          });
          this.searchColumns = Object.entries(obj).reduce((a, [k, v]) => (v == null ? a : (a[k] = v, a)), {}) //Filter all falsy values ( null, undefined )
          this.row['searchColumns'] = this.searchColumns
          return of(this.onCRUDRequested(CrudType.GET, this.row));
        })
      )
      .subscribe();
  }

  getRequiredListData(pageIndex?: string, pageSize?: string, otherParams?: object) {
    this.loading = true;
    otherParams = { ...otherParams, IsAll: true, userId: this.userData?.userId }
    this.otherParams = otherParams;
    let InventoryModuleApiSuffixModels: InventoryModuleApiSuffixModels;
    InventoryModuleApiSuffixModels = this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].apiSuffixModel;
    this.commonService.get(
      ModulesBasedApiSuffix.TECHNICIAN,
      InventoryModuleApiSuffixModels,
      undefined,
      false, prepareGetRequestHttpParams(pageIndex, pageSize, otherParams)
    ).subscribe(data => {
      this.loading = false;
      this.rxjsService.setGlobalLoaderProperty(false);
      if (data.isSuccess) {
        this.observableResponse = data.resources;
        this.dataList = this.observableResponse;
        // this.selectedRows = []
        // data.resources.forEach(element => {
        //   if (element.isActive) {
        //     this.selectedRows.push(element)
        //   }
        // });
        this.totalRecords = data.totalCount;
      } else {
        this.observableResponse = null;
        this.dataList = this.observableResponse
        this.totalRecords = 0;

      }
    })
  }

  loadPaginationLazy(event) {
    let row = {}
    row['pageIndex'] = event.first / event.rows;
    row["pageSize"] = event.rows;
    row["sortOrderColumn"] = event.sortField;
    row["sortOrder"] = event.sortOrder == 1 ? 'ASC' : 'DESC';
    this.row = row;
    this.onCRUDRequested(CrudType.GET, this.row);
  }

  onCRUDRequested(type: CrudType | string, row?: object, unknownVar?: number | string): void {
    switch (type) {
      case CrudType.CREATE:
        this.openAddEditPage(CrudType.CREATE, row);
        break;
      case CrudType.GET:
        let otherParams = {};
        if (this.searchForm.value.searchKeyword) {
          otherParams["search"] = this.searchForm.value.searchKeyword;
        }
        if (Object.keys(this.row).length > 0) {
          // logic for split columns and its values to key value pair

          if (this.row['searchColumns']) {
            Object.keys(this.row['searchColumns']).forEach((key) => {
              if (key.toLowerCase().includes('date')) {
                otherParams[key] = this.momentService.localToUTCDateTime(this.row['searchColumns'][key]);
              } else {
                otherParams[key] = this.row['searchColumns'][key];
              }
            });
          }
          if (this.row['sortOrderColumn']) {
            otherParams['sortOrder'] = this.row['sortOrder'];
            otherParams['sortOrderColumn'] = this.row['sortOrderColumn'];
          }
        }
        //otherParams['UserId'] = this.userData.userId;
        this.getRequiredListData(this.row["pageIndex"], this.row["pageSize"], otherParams)
        break;
      case CrudType.EDIT:
        if (!this.isEdit) {
          return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
        }
        this.openAddEditPage(CrudType.VIEW, row);
        break;
      case CrudType.EXPORT:
        let pageIndex = this.row && this.row["pageIndex"] ? this.row["pageIndex"] : 0;
        let pageSize = this.row && this.row["pageSize"] ? this.row["pageSize"] : 10;
        this.exportList(pageIndex, pageSize);
        break;
      case CrudType.SCAN:
         this.isScan = true;
        break;
      default:
    }
  }
  close(){
    this.isScan = false;
  }
  checkScanItem(){

   if(!this.scanQrInput){
    this.snackbarService.openSnackbar("Please enter QR Code to scan.",ResponseMessageTypes.WARNING);
    return;
   }
   this.commonService.get(
    ModulesBasedApiSuffix.TECHNICIAN,
    InventoryModuleApiSuffixModels.TECHNICIAN_STOCK_TAKE_VALIDATE_QRCODE,
    undefined,
    false, prepareRequiredHttpParams({QRCode:this.scanQrInput,TechStockTakeId:this.userData.userId})
  ).subscribe((response:any) => {
    if(response?.isSuccess && response.resources){
      this.isScan=false;
      this.router.navigate(['/inventory', 'job-selection', 'tech-stock-take-scan'], {
        queryParams: {
          scanQrInput:this.scanQrInput,
          id:response.resources.techStockTakeId,
          isEdit:this.isEdit
        }, skipLocationChange: true
      });
    }
    this.rxjsService.setGlobalLoaderProperty(false); 
  })
  }
  exportList(pageIndex?: any, pageSize?: any, otherParams?: object) {
    let queryParams;
    queryParams = this.generateQueryParams(otherParams,pageIndex,pageSize);
    let exportapi =  InventoryModuleApiSuffixModels.TECHNICIAN_STOCK_TAKE_EXPORT
    let label = 'Technician Stock Take';
    this.commonService.downloadFile(ModulesBasedApiSuffix.TECHNICIAN,
      exportapi,null, null, queryParams).subscribe((response: any) => {
        this.rxjsService.setGlobalLoaderProperty(false);
        if (response) {
          this.saveAsExcelFile(response, label);
          this.rxjsService.setGlobalLoaderProperty(false);
        }
    });
  }
  generateQueryParams(otherParams,pageIndex,pageSize) {

    let queryParamsString;
    queryParamsString = new HttpParams({ fromObject:this.otherParams })
    .set('pageIndex',pageIndex)
    .set('pageSize',pageSize);

     queryParamsString.toString();
     return queryParamsString;
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    });
  }

  onTabChange(event) {
    this.row = {}
    this.columnFilterForm = this._fb.group({})
    this.columnFilterForm = this.tableFilterFormService.createFormGroup(this.primengTableConfigProperties.tableComponentConfigs.tabsList[event.index].columns);
    this.columnFilterRequest();
    this.dataList = [];
    this.totalRecords = null;
    this.selectedTabIndex = event.index
    this.router.navigate(['/inventory/job-selection'], { queryParams: { tab: this.selectedTabIndex } })
    this.getRequiredListData()
  }

  openAddEditPage(type: CrudType | string, editableObject?: object | string, index?: number): void {
    switch (type) {
      case CrudType.VIEW:
        this.router.navigate(['/inventory', 'job-selection', 'tech-stock-take-scan'], {
          queryParams: {
            id: editableObject['techStockTakeId'],
            scanQrInput: editableObject['qrCode'],
            isEdit:this.isEdit
            // stockIterationId: editableObject['techStockTakeIterationId'],
          }, skipLocationChange: true
        });
        break;
    }
  }

  navigateToJobSelection() {
    this.router.navigate(['/inventory', 'job-selection'], { skipLocationChange: true });
  }
}
